module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-token-auth"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [(_vm.state === 'company-info') ? _c('company-info', {
    attrs: {
      "default-info": _vm.companyInfo
    },
    on: {
      "saved": _vm.postSAMLAuth
    }
  }) : _vm._e(), (_vm.state === 'gdpr-consent') ? _c('gdpr-consent', {
    on: {
      "seen": _vm.postSAMLAuth
    }
  }) : _vm._e(), (_vm.state === 'app-consent') ? _c('app-consent', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    }
  }) : _vm._e(), (_vm.state === 'normal') ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74cda355","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SAMLAuth/SAMLAuth.vue
// module id = 606
// module chunks = 1